module.exports = __webpack_public_path__ + "static/media/taLogoReverse_v2.9c6730ee.jpg";